"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageModulesModule = void 0;
var error_helper_const_1 = require("@const/error-handling/error-helper.const");
var module_mapping_1 = require("@const/module.mapping");
var reference_object_const_1 = require("@const/reference-object.const");
var object_service_1 = require("@services/object-service");
var translation_1 = __importDefault(require("@services/translation"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importStar(require("lodash"));
var fitpos_api_1 = require("../../../api/fitpos-api");
var data_processing_service_1 = require("../services/data-processing.service");
var ManageModulesModule = /** @class */ (function () {
    function ManageModulesModule() {
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.purchasableModules = [];
        this.disallowPurchase = false;
        this.selectedModules = [];
    }
    ManageModulesModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contracts, moduleRef, _loop_1, this_1, _i, contracts_1, contract, _ActionMapping;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 1:
                        _a.contracts = _b.sent();
                        if (this.contracts.length > 1) {
                            //currently multiple contracts are not compatible with our ui
                            alert('Entschuldige, aber aktuell können wir die Funktion nicht bei mehreren Verträgen anbieten.');
                            moduleDiv
                                .querySelectorAll('[data-action="submit"]')
                                .forEach(function (a) { return (a['style'].background = 'gray'); });
                            this.disallowPurchase = true;
                        }
                        this.refObjects = module_mapping_1._AddonSelectionReferences;
                        this.htmlModule = moduleDiv;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 2:
                        contracts = _b.sent();
                        (0, reference_object_const_1._RefObjectFinder)((0, cash_dom_1.default)(this.htmlModule).find('[data-ref="module-container"]'), this.refObjects);
                        moduleRef = this.htmlModule.querySelector('[data-ref="pricing-block"]');
                        if (moduleRef) {
                            this.pricingBlockContainer = this.htmlModule.querySelector('[data-ref="pricing-block-container"]');
                            this.pricingBlock = moduleRef.cloneNode(true);
                            moduleRef.remove();
                        }
                        _loop_1 = function (contract) {
                            var modules;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this_1.fitposAPI.getCustomerModuleData(customer.id, contract.id)];
                                    case 1:
                                        modules = _c.sent();
                                        modules.forEach(function (a) {
                                            a.contractId = contract.id;
                                            a.totalFrequency =
                                                a.paymentFrequencies.find(function (a) { var _a; return (_a = a === null || a === void 0 ? void 0 : a.term) === null || _a === void 0 ? void 0 : _a.unit; }).term.unit || '';
                                            a.totalUnit =
                                                a.paymentFrequencies.find(function (a) { var _a; return (_a = a === null || a === void 0 ? void 0 : a.price) === null || _a === void 0 ? void 0 : _a.currency; }).price.currency ||
                                                    '';
                                            a.totalPrice = _this.sumByPath(a.paymentFrequencies, 'price.amount');
                                        });
                                        this_1.purchasableModules = this_1.purchasableModules.concat(modules);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, contracts_1 = contracts;
                        _b.label = 3;
                    case 3:
                        if (!(_i < contracts_1.length)) return [3 /*break*/, 6];
                        contract = contracts_1[_i];
                        return [5 /*yield**/, _loop_1(contract)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6:
                        this.renderModules(this.purchasableModules);
                        this.htmlModule
                            .querySelector('[data-reset="true"]')
                            .addEventListener('mouseUp', function () {
                            _this.selectedModules = [];
                            _this.renderModules(_this.purchasableModules);
                        });
                        _ActionMapping = {
                            submit: function (event) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.submitBooking(event, customer)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                        };
                        this.dataProcessing.mapDataAction(moduleDiv, _ActionMapping);
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageModulesModule.prototype.submitBooking = function (event, customer) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, module_1, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.disallowPurchase) {
                            alert('Entschuldige, aber aktuell können wir die Funktion nicht bei mehreren Verträgen anbieten.');
                            return [2 /*return*/];
                        }
                        (0, generator_const_1._CreateLoadingScreen)();
                        if (!this.selectedModules.length) return [3 /*break*/, 8];
                        console.log('submiut', event, customer, this.selectedModules);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        _i = 0, _a = this.selectedModules;
                        _b.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        module_1 = _a[_i];
                        return [4 /*yield*/, this.fitposAPI.postAdditionalModuleContract(customer.id, module_1.contractId, {
                                additionalModuleId: module_1.id,
                                paymentFrequencyId: module_1.paymentFrequencies[0].id,
                                bookTrialPeriod: false,
                            })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        if (this.htmlModule.querySelector('[data-redirect]')) {
                            console.log('REDIRECT', this.htmlModule.querySelector('[data-redirect]'));
                            window.location.href = this.htmlModule
                                .querySelector('[data-redirect]')
                                .getAttribute('data-redirect');
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _b.sent();
                        console.log('error', e_1);
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        (0, error_helper_const_1._AddToastMessage)((0, cash_dom_1.default)(this.htmlModule), translation_1.default.t('Bitte wähle zuerst das upgrade das du buchen möchtest.'), { timer: 3000 });
                        _b.label = 9;
                    case 9:
                        (0, generator_const_1._DeleteLoadingScreen)();
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageModulesModule.prototype.renderModules = function (purchasableModules) {
        return __awaiter(this, void 0, void 0, function () {
            var container, index, _loop_2, this_2, _i, purchasableModules_1, module_2;
            var _this = this;
            return __generator(this, function (_a) {
                container = this.htmlModule.querySelector('[data-ref="module-container"]');
                if (!container) {
                    console.error('No container for modules found: [data-ref="module-container"]');
                    return [2 /*return*/];
                }
                container.innerHTML = '';
                if (purchasableModules.length === 0) {
                    container.appendChild(this.refObjects.refObjectNoModule.domElement.clone().get(0));
                    return [2 /*return*/];
                }
                index = 0;
                _loop_2 = function (module_2) {
                    var selectable = this_2.refObjects.refObjectSelectableModules.domElement
                        .clone()
                        .get(0);
                    if (this_2.selectedModules.some(function (a) { return a.id === module_2.id; })) {
                        selectable = this_2.refObjects.refObjectSelectedModules.domElement
                            .clone()
                            .get(0);
                    }
                    selectable.addEventListener('mouseup', function () {
                        var index = _this.selectedModules.findIndex(function (a) { return a.id === module_2.id; });
                        if (index >= 0) {
                            _this.selectedModules.splice(index, 1);
                        }
                        else {
                            _this.selectedModules.push(module_2);
                        }
                        _this.renderModules(purchasableModules);
                    });
                    selectable.querySelectorAll('[data-get]').forEach(function (a) {
                        var attr = a.getAttribute('data-get');
                        if (attr === 'price' || attr === 'totalPrice') {
                            a.innerHTML = translation_1.default.transformCurrency((0, lodash_1.get)(module_2, attr || ''));
                        }
                        else if (attr === 'count') {
                            a.innerHTML = String(index + 1);
                        }
                        else if (attr === 'paymentFrequencies') {
                            a.innerHTML = String(module_2.paymentFrequencies.find(function (a) { return a.term.unit; }));
                        }
                        else {
                            a.innerHTML = translation_1.default.t((0, lodash_1.get)(module_2, attr || ''));
                        }
                    });
                    console.log(this_2.selectedModules, 'this.selectedModules');
                    //Show price overview only if module selected
                    var priceOverview = this_2.htmlModule.querySelector('[data-show="onModuleSelected"]');
                    if (priceOverview) {
                        if (this_2.selectedModules.length) {
                            priceOverview['style'].display = 'flex';
                            this_2.pricingBlockContainer.innerHTML = '';
                            //sum up modules with same pricing structure to have a more consistent ui
                            var samePricingModules = [];
                            var _loop_3 = function (entry) {
                                var exists = samePricingModules.find(function (a) {
                                    return a.totalFrequency === entry.totalFrequency &&
                                        a.totalUnit === entry.totalUnit;
                                });
                                if (exists) {
                                    exists.totalPrice += +entry.totalPrice;
                                }
                                else {
                                    samePricingModules.push(lodash_1.default.cloneDeep(entry));
                                }
                            };
                            for (var _b = 0, _c = this_2.selectedModules; _b < _c.length; _b++) {
                                var entry = _c[_b];
                                _loop_3(entry);
                            }
                            var _loop_4 = function (entry) {
                                var clone = this_2.pricingBlock.cloneNode(true);
                                clone.querySelectorAll('[data-get]').forEach(function (a) {
                                    var attr = a.getAttribute('data-get');
                                    if (attr === 'totalPrice') {
                                        a.innerHTML = translation_1.default.t(String(translation_1.default.transformCurrency(entry.totalPrice)));
                                    }
                                    else if (attr === 'totalFrequency') {
                                        a.innerHTML = translation_1.default.t(String(entry.totalFrequency));
                                    }
                                    else if (attr === 'totalUnit') {
                                        a.innerHTML = translation_1.default.t(String(entry.totalUnit));
                                    }
                                    else {
                                        a.innerHTML = translation_1.default.t((0, lodash_1.get)(module_2, attr || ''));
                                    }
                                });
                                this_2.pricingBlockContainer.appendChild(clone);
                            };
                            for (var _d = 0, samePricingModules_1 = samePricingModules; _d < samePricingModules_1.length; _d++) {
                                var entry = samePricingModules_1[_d];
                                _loop_4(entry);
                            }
                        }
                        else {
                            priceOverview['style'].display = 'none';
                        }
                    }
                    //Deactivate submit button if no module is selected for purchase
                    if (this_2.selectedModules.length) {
                        this_2.htmlModule
                            .querySelector('[data-action="submit"]')
                            .removeAttribute('disabled');
                    }
                    else {
                        this_2.htmlModule
                            .querySelector('[data-action="submit"]')
                            .setAttribute('disabled', 'true');
                    }
                    container.appendChild(selectable);
                    index++;
                };
                this_2 = this;
                for (_i = 0, purchasableModules_1 = purchasableModules; _i < purchasableModules_1.length; _i++) {
                    module_2 = purchasableModules_1[_i];
                    _loop_2(module_2);
                }
                return [2 /*return*/];
            });
        });
    };
    ManageModulesModule.prototype.sumByPath = function (arr, path) {
        return lodash_1.default.sumBy(arr, function (obj) { return Number(lodash_1.default.get(obj, path, 0) || 0); });
    };
    return ManageModulesModule;
}());
exports.ManageModulesModule = ManageModulesModule;
